import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatusPill } from '../../../models/shared/status-pill';
import { StatusPillComponent } from '../status-pill.component';

@Component({
  selector: 'app-current-employer-pill',
  templateUrl: './current-employer-pill.component.html',
  standalone: true,
  imports: [StatusPillComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrentEmployerPillComponent {
  protected readonly pill = new StatusPill(1, $localize`Current Employer`, '#0D5D4B', '#E8F3F1');
}
